import { Component, EventEmitter, Input, OnChanges, Output, signal } from '@angular/core';
import { IMPORTS, PROVIDERS } from './_imports';

@Component({
    selector: 'datetime-picker',
    templateUrl: './datetime-picker.component.html',
    styleUrl: './datetime-picker.component.scss',
    standalone: true,
    imports: IMPORTS,
    providers: PROVIDERS
})
export class DateTimePickerComponent implements OnChanges {
    // #region [signals]
    $disabled = signal(false);
    $value = signal(null as any);
    // #endregion

    // #region [Input/Output]
    @Input('disabled') _disabled: boolean;
    @Input('value') _value: any = null;
    @Output('valueChange') _valueChange = new EventEmitter<any>();
    // #endregion

    constructor() { }

    ngOnChanges() {
        this.$disabled.set(this._disabled);
        this.$value.set(this._value);
    }

    onChange(event) {
        this.$value.set(event);
        this._valueChange.emit(this.$value());
    }

    clear() {
        this.$value.set(null);
        this._valueChange.emit(this.$value());
    }

    // #region [===== private methods =====]
    // #endregion
}
